import { makeClassnames } from '../functions';

var FlagIcon = function FlagIcon(React, options, styles) {
  return function (props) {
    var _props$Component = props.Component,
        Component = _props$Component === void 0 ? 'span' : _props$Component,
        children = props.children;
    return React.createElement(Component, {
      className: makeClassnames(props, options, styles)
    }, children);
  };
};

export default FlagIcon;